import axios from "axios";

export function updateCheckoutDetail(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/distributor/admin/api/v1/checkout/${parameters.uuid}/update`, {
        remark: parameters.remark,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
